(function () {
    'ngInject';

    angular.module('app.shared.services').factory('SpotifyAPIService', spotifyAPIService);

    function spotifyAPIService(HttpService) {        

        async function getToken(username) {                        
            return HttpService.get('/Spotify/GetToken?username='+username);            
        }

        async function getTrackInfo(access_token, trackName) {
            const response = await fetch(`https://api.spotify.com/v1/search?q=${trackName}&type=track`, {
                method: 'GET',
                headers: { Authorization: 'Bearer ' + access_token }
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || response.statusText);
            }
            
            return await response.json();
        }

        async function fetchTrack(trackName, username) {
            try {
                const tokenResponse = JSON.parse(await getToken(username));                                
                const trackInfo = await getTrackInfo(tokenResponse.access_token, trackName);                
                return trackInfo; // Return the fetched track info
            } catch (error) {
                console.error('Error fetching track:', error);
                throw error; // Ensure the error is propagated
            }
        }

        return {
            fetchTrack
        };
    }
})();
